import { useEffect } from 'react';
import Select from 'react-select';
import { LoadScript } from '@react-google-maps/api';
import PhoneInput from 'react-phone-input-2'
import FormikInput from '@/Component/Common/Forms/FormikInput'
import FormikTextarea from '@/Component/Common/Forms/FormikTextarea'
import FormLabel from '@/Component/Common/Forms/FormLabel'
import GoogleAddressAutocomplete from '@/Utils/Other/GoogleAddressAutocomplete';
import { ErrorMessage } from 'formik';
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg';
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';

const QuickApplyForm = (props) => {
    const { values, setFieldValue, userDetails, campaignData, errors, translations, composerRef } = props;

    return (
        <div className="grid grid-cols-12 md:gap-y-6 gap-y-3 gap-x-3">
            {campaignData?.is_barter === "false" ? (
                <div className="flex flex-col col-span-12">
                    <FormLabel title={`${translations?.cash} ${translations?.budget} (${campaignData?.currency})`} />
                    <div className='relative'>
                        <span className='absolute top-[50%] translate-y-[-50%] left-3 text-lg'>$</span>
                        <FormikInput inputProps={{
                            onFocus: () => {
                                const inputEl = document.querySelector('.cometchat-message-composer__input  ');
                                if (inputEl instanceof HTMLElement) {
                                    inputEl.blur();
                                }
                            },
                            onKeyDown: (e) => {
                                if (['.', 'e', '+', '-'].includes(e.key)) {
                                    e.preventDefault();
                                }
                            },
                            disabled: campaignData?.is_barter === "true",
                            type: "text",
                            name: "influencer_budget"
                        }}
                            customClass={`pl-6 pr-36 ${campaignData?.is_barter === "true" ? 'cursor-not-allowed' : ''}`} onlyNumber
                        />
                        {campaignData?.is_barter === "false" && <span className='absolute top-[50%] translate-y-[-50%] right-3 text-sm text-gray'>{translations?.canEditAmount}</span>}
                    </div>
                    <ErrorMessage name="influencer_budget" component="div" render={(msg) =>
                        <ValidationMsg errorMsg={errors?.influencer_budget} />
                    } />
                </div>
            ) :
                <span className='text-green-600 col-span-12'>
                    {translations?.applyNote1} ${campaignData?.product_value} {campaignData?.currency} {translations?.applyNote2}
                </span>
            }
            <div className="flex flex-col col-span-12">
                <FormLabel title={`${translations?.messageTo} ${campaignData?.users?.first_name} ${campaignData?.users?.last_name} (${translations?.optional})`} />
                <FormikTextarea textareaProps={{ type: "text", name: "message", autoComplete: "new-email", placeholder: `${translations?.messagePlaceholder}` }} />
                {/* <ErrorMessage name="message" component="div" render={(msg) =>
                    <ValidationMsg errorMsg={msg} />
                } /> */}
            </div>
        </div>
    )
}

export default QuickApplyForm
